import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { IChangePasswordRequest } from '../interfaces/auth/auth.interface';

import { HttpBaseApi } from './base-http.api';
import { SKIP_ERROR_TOAST } from './error.iterceptor';

/** Вход (CRM-122). Ошибки показывают сами формы — без тоста. */
@Injectable({ providedIn: 'root' })
export class AuthApi extends HttpBaseApi {
  private readonly _http = inject(HttpClient);
  private readonly _silent = () => ({ context: new HttpContext().set(SKIP_ERROR_TOAST, true) });

  public login(login: string, password: string): Observable<void> {
    return this._http.post<void>(this.buildUrl('auth/login'), { login, password }, this._silent());
  }

  public logout(): Observable<void> {
    return this._http.post<void>(this.buildUrl('auth/logout'), null, this._silent());
  }

  public changePassword(request: IChangePasswordRequest): Observable<void> {
    return this._http.post<void>(this.buildUrl('auth/password'), request, this._silent());
  }
}
